module.exports = __webpack_public_path__ + "img/plans.5134cb06.jpg";